//import _ from 'lodash'
import moment from "moment";
import React from "react";

import { AdverseEventDetail } from "./AdverseEventDetail";
import { ProductDetail } from "./ProductDetail";
import { ReporterDetail } from "./ReporterDetail";
import { SourceDetail } from "./SourceDetail";

//import {
//    Icon,
//    Button
//} from 'semantic-ui-react'

function formatDateForDisplay(date) {
  const isValid = moment(date || null).isValid();
  if (!isValid) {
    return "N/A";
  }

  const isFirstOfMonth = moment(date).date() === 1;
  const isJanuary = moment(date).month() === 0;

  if (isFirstOfMonth && isJanuary) {
    return moment(date).format("--/---/YYYY");
  } else if (isFirstOfMonth) {
    return moment(date).format("--/MMM/YYYY");
  } else {
    return moment(date).format("D/MMM/YYYY");
  }
}

export const configColumns = [
  {
    field: "SOURCE_SYSTEM",
    ID: "SOURCE_SYSTEM",
    title: "Source System",
    filterable: {
      type: "remoteMultiFilter",
      props: { field: "SOURCE_SYSTEM", table: "CASES" }
    }
  },
  {
    field: "AER_NO",
    ID: "AER_NO",
    title: "AER No.",
    filterable: {
      type: "remoteMultiFilter",
      props: { field: "AER_NO", table: "CASES" }
    }
  },
  {
    field: "LAM_CASE_NO",
    ID: "LAM_CASE_NO",
    title: "LAM Case No.",
    filterable: {
      type: "remoteMultiFilter",
      props: { field: "LAM_CASE_NO", table: "CASES" }
    }
  },
  {
    field: "ARGUS_CASE_NO",
    ID: "ARGUS_CASE_NO",
    title: "ARGUS Case No.",
    filterable: {
      type: "remoteMultiFilter",
      props: { field: "ARGUS_CASE_NO", table: "CASES" }
    }
  },
  {
    field: "AER_DELETED",
    ID: "AER_DELETED",
    title: "Case Deleted?",
    hidden: true,
    filterable: {
      type: "remoteMultiFilter",
      props: { field: "AER_DELETED", table: "CASES" }
    }
  },
  {
    field: "VERSION_NO",
    ID: "VERSION_NO",
    title: "Version No.",
    hidden: true,
    filterable: {
      type: "remoteMultiFilter",
      props: { field: "VERSION_NO", table: "CASES" }
    }
  },
  {
    field: "AER_COUNTRY",
    ID: "AER_COUNTRY",
    title: "Primary Source Country",
    filterable: {
      type: "remoteMultiFilter",
      props: { field: "AER_COUNTRY", table: "CASES" }
    }
  },
  {
    field: "COUNTRY_OF_DETECTION",
    ID: "COUNTRY_OF_DETECTION",
    title: "Country of Detection",
    hidden: true,
    filterable: {
      type: "remoteMultiFilter",
      props: { field: "COUNTRY_OF_DETECTION", table: "CASES" }
    }
  },
  {
    field: "AER_RECV_DATE",
    ID: "AER_RECV_DATE",
    title: "Latest Received Date",
    filterable: {
      type: "dateFilter",
      props: { field: "AER_RECV_DATE", table: "CASES" }
    },
    template: item => {
      return <div>{formatDateForDisplay(item.AER_RECV_DATE)}</div>;
    }
  },
  {
    field: "PATIENT_ID",
    ID: "PATIENT_ID",
    title: "Patient ID",
    filterable: {
      type: "remoteMultiFilter",
      props: { field: "PATIENT_ID", table: "CASES" }
    }
  },
  {
    field: "AGE",
    ID: "AGE",
    title: "Age at Time of Event",
    filterable: {
      type: "remoteMultiFilter",
      props: { field: "AGE", table: "CASES" }
    }
  },
  {
    field: "AGE_UNIT",
    ID: "AGE_UNIT",
    title: "Age at Time of Event (unit)",
    filterable: {
      type: "remoteMultiFilter",
      props: { field: "AGE_UNIT", table: "CASES" }
    }
  },
  {
    field: "SEX",
    ID: "SEX",
    title: "Patient Gender",
    filterable: {
      type: "remoteMultiFilter",
      props: { field: "SEX", table: "CASES" }
    }
  },
  {
    field: "DOB",
    ID: "DOB",
    title: "Patient DOB",
    filterable: { type: "dateFilter", props: { field: "DOB", table: "CASES" } },
    template: item => {
      return <div>{formatDateForDisplay(item.DOB)}</div>;
    }
    //filterable: { type: 'multiFilter' }
  },
  {
    field: "STUDY_PATIENT_NO",
    ID: "STUDY_PATIENT_NO",
    title: "Study/Third Party Patient No.",
    filterable: {
      type: "remoteMultiFilter",
      props: { field: "STUDY_PATIENT_NO", table: "CASES" }
    }
  },
  {
    field: "PROTOCOL_NO",
    ID: "PROTOCOL_NO",
    title: "Protocol/Study No.",
    filterable: {
      type: "remoteMultiFilter",
      props: { field: "PROTOCOL_NO", table: "CASES" }
    }
  },
  {
    field: "KEYWORDS",
    ID: "KEYWORDS",
    title: "Keywords",
    filterable: {
      type: "remoteMultiFilter",
      props: { field: "KEYWORDS", table: "CASES" }
    },
    template: item => {
      return <div>{(item.KEYWORDS || []).join(", ")}</div>;
    }
  },
  {
    ID: "REPORTER",
    table: "REPORTERS",
    title: "Reporter",
    filterable: { type: "reporterFilter" },
    sortDisabled: true,
    groupByDisabled: true,
    template: item => {
      return (
        <ReporterDetail record_id={item.RECORD_ID} reporters={item.REPORTERS} />
      );
    }
  },
  {
    ID: "PRODUCT",
    table: "PRODUCTS",
    title: "Product",
    filterable: { type: "productFilter" },
    sortDisabled: true,
    groupByDisabled: true,
    template: item => {
      return (
        <ProductDetail record_id={item.RECORD_ID} products={item.PRODUCTS} />
      );
    }
  },
  {
    ID: "ADVERSE_EVENT",
    table: "ADVERSE_EVENTS",
    title: "Adverse Event",
    filterable: { type: "aeFilter" },
    sortDisabled: true,
    groupByDisabled: true,
    template: item => {
      return <AdverseEventDetail record_id={item.RECORD_ID} aes={item.AES} />;
    }
  },
  {
    ID: "SOURCE",
    table: "SOURCES",
    title: "Source",
    filterable: { type: "sourceFilter" },
    sortDisabled: true,
    groupByDisabled: true,
    template: item => {
      return <SourceDetail record_id={item.RECORD_ID} />;
    }
  }
];



// WEBPACK FOOTER //
// ./src/Components/Config.js